// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    FindWarehouseData,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { ProductInventoryDto, WarehouseDto } from "@insite/client-framework/Types/ApiModels";

export interface ExtendedResult {
    errorMessage: string;
    warehouses?: WarehouseDto[];
    branches?: string;
}

type ExtendedHandlerType = Handler<
    GetProductRealTimeInventoryApiV2Parameter & {
        onComplete: (result: ExtendedResult) => void;
        unitOfMeasure: string;
    },
    {
        apiParameter: GetProductRealTimeInventoryApiV2Parameter;
        apiResult?: ProductInventoryDto;
        result: ExtendedResult;
    }
>;
// XNG-Changes : to get branches data
export const FindBranches: ExtendedHandlerType = props => {
    if (props.apiResult?.additionalResults) {
        const { branches } = props.apiResult.additionalResults;

        if (branches) {
            props.result = {
                ...props.result,
                branches,
            };
        }
    }
};
addToChainAfter(chain, FindWarehouseData, FindBranches);
